import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { NavBar, Footer } from "../components/ReusableElements";
import Fade from "react-reveal/Fade";
import logo from "../assets/crop-logo.png";
import home from "../assets/home-image.png";
import "../styles/Home.css";

export default class Home extends Component {
  constructor() {
    super();

    this.state = {};
  }

  render() {
    return (
      <div>
        <div className="Home" id="page">
          <NavBar
            isLoggedIn={this.props.isLoggedIn}
            logout={this.props.toggleIsLoggedIn}
          />
          <div className="home-box">
            <Fade bottom>
              <div className="home-cartoon">
                <img src={home} alt="" height="100%" width="100%" />
              </div>
            </Fade>
            <div id="home-text-box">
              <div className="home-title">
                Carousell Rights Owners Programme
              </div>
              <body className="home-description">
                Carousell takes a strong stance against intellectual property
                infringement on our platform.
                <br /> As such, we are committed to work with brand owners
                through our CROP program.
              </body>

              <NavLink to="/about">
                <button className="home-find-out-more" type="button">
                  Find Out More
                </button>
              </NavLink>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js